/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Not_PersistedInputs */

const en_consent_not_persisted = /** @type {(inputs: Consent_Not_PersistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser is blocking storage, so we cannot remember this choice for your next visit. We are honouring it here.`)
};

/**
* | output |
* | --- |
* | "Your browser is blocking storage, so we cannot remember this choice for your next visit. We are honouring it here." |
*
* @param {Consent_Not_PersistedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_not_persisted = /** @type {((inputs?: Consent_Not_PersistedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Not_PersistedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_not_persisted(inputs)
});